export default "/images/3226f8ed5c18537fc7908e9b72da0bef.avif";